
define( 'FORCES_AND_MOTION_BASICS/../nls/es-es/forces-and-motion-basics-strings',{
          "none": "Nada",
          "force": "Fuerza",
          "values": "Valores",
          "frictionTitle": "Fricción",
          "redWins": "¡Ganan los rojos!",
          "frictionForce": "Fuerza de Fricción",
          "pause": "Pausa",
          "friction": "Fricción",
          "forces-and-motion-basics.name": "Fuerzas y Movimiento:Fundamentos",
          "appliedForce": "Fuerza Aplicada",
          "leftForce": "Fuerza Izquierda",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Fuerza Derecha",
          "sound": "Sonido",
          "lots": "Mucho",
          "forces": "Fuerzas",
          "motion": "Movimiento",
          "tugOfWar": "Tira y Afloja",
          "go": "¡Vaya!",
          "newtons.n": "Newtons (N)",
          "sumOfForcesEqualsZero": "Suma de Fuerza = 0",
          "blueWins": "¡Ganan los azules!",
          "speed": "Velocidad",
          "sumOfForces": "Suma de Fuerzas",
          "return": "Retornar",
          "translation.credits": "Por Héctor R. MALLMA ALVARADO (UNFV)(LIMA-PERÚ) hecmall@hotmail.com; hecmall@outlook.com",
          "newtons": "Newtons",
          "masses": "Masas",
          "forceReadout.pattern": "{0}N"
        } );